import React, { useContext, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ProjectContext } from '../../context/ProjectContext';
import { LanguageContext } from '../../context/LanguageContext';
import HeroSection from '../../components/HeroSection/HeroSection';
import ProjectsGallery from '../../components/ProjectsGallery/ProjectsGallery';
import VideosSection from '../../components/VideosSection/VideosSection';
import SocialMedia from '../../components/SocialMedia/SocialMedia';
import ContactForm from '../../components/ContactForm/ContactForm';
import VariableProximity from '../../components/VariableProximity/VariableProximity';
import './Home.css';

const Home = () => {
  const { projects, carouselImages } = useContext(ProjectContext);
  const { t } = useContext(LanguageContext);
  const quoteContainerRef = useRef(null);

  // Obtener los últimos 3 proyectos agregados (ordenados por fecha de creación o ID descendente)
  const latestProjects = projects
    .sort((a, b) => {
      // Ordenar por created_at si existe, sino por id (más reciente primero)
      if (a.created_at && b.created_at) {
        return new Date(b.created_at) - new Date(a.created_at);
      }
      return (b.id || 0) - (a.id || 0);
    })
    .slice(0, 3);

  // Imagen del hero desde el contexto (gestionadas desde el admin)
  // Solo usar la primera imagen para diseño tipo portafolio
  const heroImage = carouselImages && carouselImages.length > 0 ? carouselImages[0] : null;

  return (
    <div className="page-container">
      {/* Hero Section tipo portafolio con imagen de fondo y nombre superpuesto */}
      <HeroSection
        title="SINN3RS"
        subtitle=""
        images={heroImage ? [heroImage] : []}
        portfolioMode={true}
      />

      {/* Cita Principal */}
      <section className="quote-hero-section" ref={quoteContainerRef}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <div className="quote-hero-block">
                <p className="quote-hero-text">
                  <VariableProximity
                    label={'"' + (t.quoteText || 'El mundo no me hará una mala persona') + '"'}
                    containerRef={quoteContainerRef}
                    fromFontVariationSettings="'wght' 400, 'opsz' 9"
                    toFontVariationSettings="'wght' 1000, 'opsz' 40"
                    radius={150}
                    falloff="linear"
                    className="variable-proximity-quote"
                  />
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Descripción de SINN3RS */}
      <section className="description-section">
        <Container>
          <Row className="description-row">
            <Col lg={6} md={6} className="description-image-col">
              <img 
                src="/images/hero/logo.png" 
                alt="SINN3RS" 
                className="description-image"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/600x800/1a1a1a/ffffff?text=SINN3RS';
                }}
              />
            </Col>
            <Col lg={6} md={6} className="description-content-col">
              <div className="description-content">
                <p className="description-text">
                  {t.descriptionText1 || "SINN3RS representa la dualidad entre la perfección y lo imperfecto. Creemos en el arte como expresión real y emocional, donde la publicidad, el arte, la música y lo audiovisual convergen para generar impacto e identidad. Detrás de cada proyecto hay una historia que se transmite a través de la obra final."}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Videos de YouTube (orden desde el admin) */}
      <VideosSection />

      {/* Últimos Proyectos - Galería */}
      <section className="projects-section">
        <Container fluid className="projects-gallery-container">
          <h2 className="section-title">{t.featuredProjectsTitle || "Proyectos Destacados"}</h2>
          <ProjectsGallery projects={latestProjects} />
        </Container>
      </section>

      {/* Redes Sociales */}
      <section className="social-section">
        <Container>
          <SocialMedia />
        </Container>
      </section>

      {/* Formulario de Contacto */}
      <section className="contact-section">
        <Container>
          <ContactForm />
        </Container>
      </section>
    </div>
  );
};

export default Home;
